<script>
import { createEventDispatcher } from 'svelte'

//
// Props
//
export let currentPage;
export let groupId;

// 
// Event handlers
//
const dispatch = createEventDispatcher();
const onNavigate = (page) => (event) => {
    event.preventDefault();
    dispatch('navigate', page);
}

</script>

<div class="header">
    <div class="home-menu pure-menu pure-menu-horizontal pure-menu-fixed">
        <ul class="pure-menu-list">
            <li class="pure-menu-item">
                <a 
                    href="{`page=home&gid=${groupId}`}" 
                    on:click={onNavigate('home')} 
                    class="pure-menu-link" 
                    class:pure-menu-selected={currentPage === 'home'} 
                >Home</a>
                </li>
            <li class="pure-menu-item">
                <a 
                    href="{`page=submit&gid=${groupId}`}" 
                    on:click={onNavigate('submit')} 
                    class="pure-menu-link" 
                    class:pure-menu-selected={currentPage === 'submit'} 
                >Lift up</a>
            </li>
            <li class="pure-menu-item">
                <a 
                    href="{`page=receive&gid=${groupId}`}" 
                    on:click={onNavigate('receive')} 
                    class="pure-menu-link" 
                    class:pure-menu-selected={currentPage === 'receive'} 
                >Receive</a>
            </li>
        </ul>
    </div>
</div>